import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiBranchAssignmentsResponseModel } from '@/types'

export const getKpiBranchAssignments = async (
  branchName?: string,
  year?: number,
  quarter?: number,
  kpiMetric?: string
): Promise<KpiBranchAssignmentsResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/branch-assignments`, {
      params: {
        ...(branchName && { branch_name: branchName }),
        ...(year && { year: year }),
        ...(quarter && { quarter: quarter }),
        ...(kpiMetric && { kpi_metric: kpiMetric }),
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
